/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Togglesidebar1Inputs */

const zh_learn_togglesidebar1 = /** @type {(inputs: Learn_Togglesidebar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换侧边栏`)
};

const en_learn_togglesidebar1 = /** @type {(inputs: Learn_Togglesidebar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle sidebar`)
};

const es_learn_togglesidebar1 = /** @type {(inputs: Learn_Togglesidebar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar barra lateral`)
};

/**
* | output |
* | --- |
* | "Toggle sidebar" |
*
* @param {Learn_Togglesidebar1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_togglesidebar1 = /** @type {((inputs?: Learn_Togglesidebar1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Togglesidebar1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_togglesidebar1(inputs)
	if (locale === "en") return en_learn_togglesidebar1(inputs)
	return es_learn_togglesidebar1(inputs)
});
export { learn_togglesidebar1 as "learn_toggleSidebar" }